<template>
  <nav class="header" :class="{'show-menu': isMobile && showMenu}">
    <div class="nav-item iconfont icon-menu" @click="showMenu = !showMenu"></div>
    <div class="menu-list">
      <template v-for="(navItem, i) in navList">
        <router-link class="nav-item italic-font" :class="navItem.class || 'link'" :to="navItem.link" :key="i">
          {{navItem.name || ''}}
        </router-link>
      </template>
    </div>
    <div class="nav-item iconfont icon-send" @click="openSubscribeDialog"></div>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: "mew-header",
    watch: {
      '$route' () {
        if (this.isMobile && this.showMenu) {
          this.showMenu = false
        }
      }
    },
    data () {
      return {
        showMenu: false,
        navList: [
          { name: 'Collections', link: '/collections' },
          { name: 'Project', link: '/project' },
          { name: 'Shop', link: '/shop' },
          { class: 'iconfont icon-mew', link: '/' },
          { name: 'About', link: '/about' },
          { name: 'Press', link: '/press' }
        ]
      }
    },
    methods: {
      openSubscribeDialog () {
        this.$store.commit('TOGGLE', {
          key: 'subscribeDialog',
          val: true
        })
      }
    },
    computed: {
      ...mapGetters([
        'isMobile'
      ])
    }
  }
</script>

<style scoped lang="stylus">
  .header
    padding 40px 4rem
    display flex
    align-items center
    justify-content space-between
    position relative

    .menu-list
      display flex
      flex-basis 100%
      justify-content space-between
      background-color #fff

    .logo
      &:before
        content '\e600'

    .nav-item
      cursor pointer
      font-size 2.6rem
      flex-basis calc(100% / 7)
      display flex
      justify-content center
      align-items center
      &.iconfont
        font-size 3.4rem

  @media screen and (max-width: 1280px)
    .header
      .nav-item
        font-size 2.2rem

  @media screen and (max-width: 1024px)
    .header
      .nav-item
        font-size 2rem
        &.iconfont
          font-size 3rem

  @media screen and (min-width: 769px)
    .header
      .icon-menu
        display none

  @media screen and (max-width: 768px)
    .header
      padding 0
      height 60px
      position fixed
      z-index 20
      left 0
      right 0
      margin 0
      background-color #fff

      .nav-item
        &.iconfont
          font-size 20px

      &.show-menu
        .menu-list
          height auto

      .menu-list
        flex-wrap wrap
        position fixed
        left 0
        right 0
        top 60px
        z-index 20
        height 0
        overflow hidden
        transition-duration .3s
        .nav-item
          flex-basis 100%
          height 40px
          display flex
          align-items center
          order 2
          &.icon-mew
            order 1
            position fixed
            z-index 20
            transform translateX(-50%)
            left 50%
            top 0
            height 60px
            display flex
            align-items center

      .icon-menu
      .icon-send
        width 40px
        margin 0 10px
        flex initial

</style>
